import React from 'react';
import EventListCard from '../../common/events/EventListCard';
import EventListRow from '../../common/events/EventListRow';
import EventNavigationMenu from './EventNavigationMenu';

export function EventNavigableCard(props: React.ComponentProps<typeof EventListCard>) {
  return <EventListCard {...props} navigationMenu={<EventNavigationMenu event={props.event} placement="card" />} />;
}

export function EventNavigableRow(props: React.ComponentProps<typeof EventListRow>) {
  return <EventListRow {...props} navigationMenu={<EventNavigationMenu event={props.event} placement="row" />} />;
}
